import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[DepositThreshold]";
/**
 * @deprecated - [fabric-deprecated] - Use event bus retrieve with AccountAppValue.FetchThresholdStatus instead
 */
export namespace DepositThresholdAction {
	export const fetch = createAction(`${ACTION_PREFIX} fetch`);
	export const fetchFailure = createAction(`${ACTION_PREFIX} fetch failure`, (error: AppError) => ({ error }));
	export const fetchSuccess = createAction(`${ACTION_PREFIX} fetch success`, (hasReachedThreshold: boolean) => ({
		hasReachedThreshold,
	}));
}
